/*
 * ******************************************************************
 * Copyright (c) 2022-2026 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

export class LocalStoragePersistenceKeys {
    public static readonly ORGANIZATIONS: string = "organizations";
    public static readonly ORG_SUBSCRIPTIONS: string = "org-subscriptions";
    public static readonly ORG_DEPLOYMENTS: string = "org-deployments";
    public static readonly DEPLOYMENTS: string = "deployments";
    public static readonly COMPONENTS: string = "components";
    public static readonly REQUESTS: string = "requests";
    public static readonly RESOURCES: string = "resources";
    public static readonly OAUTH_APPS: string = "oauth-apps";
    public static readonly RWR_DEPLOYMENTS: string = "rwr-deployments";
    public static readonly ORG_RWR_DEPLOYMENTS: string = "org-rwr-deployments";
    public static readonly CLOUD_COST_MGMT: string = "cloud-cost-mgmt";
    public static readonly CCM_ACCOUNT_SERVICES: string = "ccm-account-services";
    public static readonly CCM_LEAKED_RESOURCES: string = "ccm-leaked-resources";
    public static readonly TASKS: string = "tasks";
    public static readonly EVENTS: string = "events";
    public static readonly ROLLOUTS: string = "rollouts";
    public static readonly ROLLOUT_WAVES: string = "rollout-waves";
    public static readonly SETUP_SITE_PREVIEWED = "setup-site-previewed";
    public static readonly TASK_NOTIFICATIONS: string = "task-notifications";
    public static readonly NOTIFICATION_ACTIONS: string = "notification-actions";

    public static readonly VLCR_SUBSCRIPTIONS: string = "vlcr_subscriptions";

    public static readonly VMCFS_SUBSCRIPTIONS: string = "vmcfs_subscriptions";
    public static readonly INCLUDE_DELETED_COMPONENTS = "include-deleted-components";
    public static readonly OFFLINE_LICENSES: string = "offline-licenses";
    public static readonly ENFORCEMENTS: string = "enforcements";
    public static readonly TRENDS_SUBSCRIPTIONS: string = "trends-subscriptions";
    public static readonly TRENDS_USAGE_VCDR: string = "trends-usage-vcdr";
    public static readonly TRENDS_USAGE_VMCFS: string = "trends-usage-vmcfs";
    public static readonly SCHEDULED_JOBS: string = "scheduled-jobs";
    public static readonly SCHEDULED_JOBS_HISTORY: string = "scheduled-jobs";
    public static readonly ROLLOUT_NOTIFICATIONS: string = "rollout-notifications";
    public static readonly WAVE_TARGETS: string = "wave-targets";
    public static readonly WAVE_ORG_TARGETS: string = "wave-org-targets";
    public static readonly APPROVAL_LOG: string = "approval-log";
    public static readonly APPROVAL_HOW_IT_WORKS_PREVIEWED = "approval-how-it-works-previewed";
    public static readonly SCRIPT_RUNNER: string = "script-runner";
    public static readonly SCRIPT_EXECUTIONS: string = "script-executions";
    public static readonly SCRIPT_TARGETS: string = "script-targets";
}
